import styled, { css } from "styled-components";

import colors from "@src/common/styles/colors";
import { defaultTransition } from "@src/common/styles/mixins";
import { DEFAULT_MARGIN_XS } from "@src/common/styles/const";

export const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 3px;
  border: 1px solid ${colors.darkBlue};
  border-radius: 8px;
  width: 60px;
  height: 30px;
  margin-left: auto;
`;

export const CheckboxOption = styled.label<{ isActive: boolean }>`
  display: flex;
  place-items: center;
  border-radius: 6px;
  padding: ${DEFAULT_MARGIN_XS}px;
  white-space: nowrap;
  text-align: center;
  cursor: pointer;
  ${defaultTransition};

  ${(p) =>
    p.isActive
      ? css`
          color: ${colors.white};
          background-color: ${colors.darkBlue};
        `
      : css`
          color: ${colors.darkBlue};
          background-color: ${colors.white};
        `}
`;

export const StyledInput = styled.input.attrs({
  type: "checkbox",
  hidden: true,
})``;
